import { Link } from "react-router-dom"
import PersonalInformation from "./PersonalInformation"
import Billing from "./Billing"
import Credits from "./Credits"
import { User, CreditCard, Globe, Bell, Lock, ChevronRight, UserCircle, LogOut, MessageCircle } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "@/context/AuthContext"
import { useTranslation } from 'react-i18next';
import { MegaphoneIcon, MegaphoneSimple } from "@phosphor-icons/react"
import { DevConsole } from "@/components/DevConsole"
import { useFlag } from '@/context/FeatureFlagContext';
import { FeatureFlagDebug } from '@/components/FeatureFlagDebug';

interface SettingsItemProps {
  icon: React.ReactNode
  label: string
  href?: string
  onClick?: () => void
  className?: string
}

export default function SettingsHome() {
  const navigate = useNavigate()
  const { logout, isDevVersion } = useAuth()
  const { t } = useTranslation();
  const isBillingEnabled = useFlag('billing');

  console.log('🎯 SettingsHome - isBillingEnabled:', isBillingEnabled);

  function SettingsItem({ icon, label, href, onClick, className }: SettingsItemProps) {
    if (onClick) {
      return (
        <button onClick={onClick} className={`flex items-center justify-between py-4 group hover:bg-gray-50 transition-colors w-full text-left ${className || ''}`}>
          <div className="flex items-center gap-3">
            {icon}
            <span className="text-gray-700">{label}</span>
          </div>
          <ChevronRight className="h-5 w-5 text-gray-400 group-hover:text-gray-500" />
        </button>
      )
    }
    return (
      <Link to={href || ''} className={`flex items-center justify-between py-4 group hover:bg-gray-50 transition-colors ${className || ''}`}>
        <div className="flex items-center gap-3">
          {icon}
          <span className="text-gray-700">{label}</span>
        </div>
        <ChevronRight className="h-5 w-5 text-gray-400 group-hover:text-gray-500" />
      </Link>
    )
  }
  return (
    <div className="bg-[#F5F3F0] overflow-hidden sm:rounded-lg">
      {isDevVersion && <FeatureFlagDebug />}
      <div className="max-w-md mx-auto p-4">
        <div className="divide-y">
          {(isDevVersion || isBillingEnabled) && (
            <div className="py-4">
              <Credits />
            </div>
          )}
          <SettingsItem
            icon={<UserCircle className="h-5 w-5 text-gray-500" />}
            label={t('settings.personalInformation')}
            href="/settings/personal-information"
          />
          <SettingsItem
            icon={<Globe className="h-5 w-5 text-gray-500" />}
            label={t('settings.personalProfile')}
            href="/settings/personal-profile"
          />

          {/*
          <SettingsItem
            icon={<CreditCard className="h-5 w-5 text-gray-500" />}
            label={t('settings.paymentsPayouts')}
            href="/settings/payments"
          />
*/}
          <SettingsItem
            className="hidden"
            icon={<Bell className="h-5 w-5 text-gray-500" />}
            label={t('settings.notifications')}
            href="/settings/notifications"
          />

          <SettingsItem
            className="hidden"
            icon={<Lock className="h-5 w-5 text-gray-500" />}
            label={t('settings.privacySharing')}
            href="/settings/privacy"
          />

          <SettingsItem
            icon={<MegaphoneSimple className="h-5 w-5 text-gray-500" />}
            label={t('settings.feedback')}
            href="/settings/feedback"
          />

          <SettingsItem
            icon={<LogOut className="h-5 w-5 text-red-500" />}
            label={t('settings.logout')}
            onClick={() => logout()}
          />
          <DevConsole />
        </div>
      </div>
    </div>
  )
}
